module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("1JlbJ"))).then(() => parcelRequire('lk6xE'));